// src/api/soportesApi.ts

import { getAuthToken } from '../security/AuthLogin';

const BASE_URL = `${window.location.protocol}//${window.location.hostname}`;
const API_URL = `${BASE_URL}/api`;

/**
 * Fetch mensajes del soporte (chat)
 * @param idSoporte - ID del soporte
 */
export async function fetchSoporteMensajes(idSoporte: number) {
  const token = getAuthToken();
  if (!token) throw new Error('No token');

  const resp = await fetch(`${API_URL}/soportes/${idSoporte}/detalles`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!resp.ok) {
    const txt = await resp.text();
    throw new Error(`Error fetchSoporteMensajes: ${txt}`);
  }
  return resp.json(); // { success: true, messages: [...] }
}

/**
 * Enviar un nuevo mensaje al soporte
 * @param idSoporte - ID del soporte
 * @param texto - Texto del mensaje
 */
export async function sendSoporteMensaje(idSoporte: number, texto: string) {
  const token = getAuthToken();
  if (!token) throw new Error('No token');

  const resp = await fetch(`${API_URL}/soportes/${idSoporte}/detalles`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ texto }),
  });
  if (!resp.ok) {
    const txt = await resp.text();
    throw new Error(`Error sendSoporteMensaje: ${txt}`);
  }
  return resp.json(); // { success: true, message: '...', id_soporte_detalle: ... }
}

/**
 * Subir un archivo al soporte
 * @param idSoporte - ID del soporte
 * @param archivo - Archivo a subir
 */
export async function subirArchivoSoporte(idSoporte: number, archivo: File) {
  const token = getAuthToken();
  if (!token) throw new Error('No token');

  const formData = new FormData();
  formData.append('archivo', archivo);

  const resp = await fetch(`${API_URL}/soportes/${idSoporte}/archivos`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      // 'Content-Type' no debe establecerse manualmente al usar FormData
    },
    body: formData,
  });

  if (!resp.ok) {
    const txt = await resp.text();
    throw new Error(`Error subirArchivoSoporte: ${txt}`);
  }

  return resp.json(); // { success: true, message: '...', archivo: '...', archivos: [...] }
}

/**
 * Obtener la lista de archivos de un soporte
 * @param idSoporte - ID del soporte
 */
export async function fetchArchivosSoporte(idSoporte: number) {
  const token = getAuthToken();
  if (!token) throw new Error('No token');

  const resp = await fetch(`${API_URL}/soportes/${idSoporte}/archivos`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  if (!resp.ok) {
    const txt = await resp.text();
    throw new Error(`Error fetchArchivosSoporte: ${txt}`);
  }

  return resp.json(); // { success: true, archivos: [...] }
}
